var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text-center mb-6"},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.app.title,"height":"50"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }